import React from 'react'

// Action tile for invoice/document components — glass button with icon,
// label and state-aware wording (Generate vs View).
export default ({ header, value, prop, display, setDocument, getDocument, showPage }) => (
  <>
    {display &&
      <button type='button' onClick={() => {
        if (!!value) {
          getDocument(value, loaded);
          function loaded(error) {
            if (!error) showPage(true);
          }
        }
        else {
          setDocument(undefined);
          showPage(true);
        }
      }} style={{
        display: 'inline-flex', alignItems: 'center', gap: 9,
        margin: '6px 8px 6px 0', padding: '9px 16px',
        borderRadius: 10, cursor: 'pointer',
        fontSize: 13, fontWeight: 700, fontFamily: 'var(--font-display, inherit)',
        background: value ? 'rgba(27,159,105,0.10)' : 'rgba(13,161,178,0.10)',
        color: value ? 'var(--success, #1B9F69)' : 'var(--primary-dark, #067886)',
        border: value ? '1px solid rgba(27,159,105,0.30)' : '1px solid rgba(13,161,178,0.30)',
      }}>
        <i className={value ? 'fas fa-file-invoice' : 'fas fa-plus'}></i>
        {!value && 'Generate '}{!!value && 'View '}{header}
        <i className="fas fa-chevron-right" style={{ fontSize: 10, opacity: 0.6 }}></i>
      </button>}
  </>
)
